import {
  Platform,
  ToastController,
  LoadingController,
  AlertController,
} from "@ionic/angular";
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Storage } from "@ionic/storage";
import { BehaviorSubject, Observable, from, of, throwError } from "rxjs";
import { take, map, switchMap, catchError, retry } from "rxjs/operators";
import { Device } from "@ionic-native/device/ngx";
import { AngularFireAuth } from "@angular/fire/auth";
//import * as firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/firestore';

import { Router } from "@angular/router";

import { environment } from "../../environments/environment";
import { PatientModel } from "../models";
import { UtilService } from "./util";

const TOKEN_KEY = "auth-token";
const PROFILE_KEY = "user-profile";
const PATIENT_KEY = "patient-";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public user$: Observable<any>;
  public authState$ = new BehaviorSubject(null);
  private userToken$ = new BehaviorSubject("");
  public userData$ = new BehaviorSubject(null);
  public userImg: any;
  /*
  {dpoint: 0
  exp: 1602049063
  iat: 1594445863
  image: "user2"
  phone: "+84905225011"
  roles: 16
  _id: "5f0950255b52191a4c3d3f9a"}
  */
  public userProfile$ = new BehaviorSubject({});
  public defaultPatient$ = new BehaviorSubject(null);
  //private userImg: any;
  private userDefaultSettings = {
    oso2Noti: true,
    docNoti: true,
    clinicNoti: true,
    userNoti: true,
  };
  public baseUrl;
  private httpOptions = {
    // Http Options
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  private loading;
  private alert;

  constructor(
    private plt: Platform,
    private afAuth: AngularFireAuth,
    private http: HttpClient,
    private router: Router,
    private storage: Storage,
    private device: Device,
    private util: UtilService //private alertCtrl: AlertController, //public toastCtrl: ToastController, //private loadingCtrl: LoadingController
  ) {
    this.baseUrl = environment.baseUrl;
    this.userImg = "/assets/images/user2.jpg";
    this.plt.ready().then(() => {
      this.checkToken();
      console.log("Auth Start: ", this.device.uuid);
    });
  }

  checkToken() {
    let self = this;
    self.storage.get(PROFILE_KEY).then((val) => {
      if (val) {
        self.userProfile$.next(val);
      }
    });
    self.storage.get(PATIENT_KEY + "DF1").then((val) => {
      val && self.defaultPatient$.next(val);
    });

    self.storage.get(TOKEN_KEY).then((token) => {
      if (token) {
        //const decoded = JSON.parse(window.atob(token.split(".")[1]));
        const decoded = JSON.parse(
          window.decodeURIComponent(
            window.escape(window.atob(token.split(".")[1]))
          )
        );
        console.log(decoded);
        if (decoded && decoded.exp && decoded.exp * 1000 > Date.now()) {
          self.userData$.next(decoded);
          self.authState$.next(true);
          self.userToken$.next(token);
          setTimeout(self._refreshToken, 5000, token, self);
        } else {
          self.authState$.next(false);
        }
      } else {
        self.authState$.next(false);
        //self.userData.next("login");
      }
    });
    /*
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    })
    */
    //firebase.auth().onAuthStateChanged((user: firebase.User) => {
    this.afAuth.onAuthStateChanged((user: firebase.User) => {
      if (user) {
        console.log(user);
        // this.authState.next(true);
      } else {
        console.log("Fb User is not logged in");
        // this.router.navigate(['/auth/login-sms']);
        //this.authState$.next(false);
      }
    });
  }

  refreshProfile() {
    if (this.userToken$.value == "") {
      return;
    }
    let self = this;
    this._refreshToken(this.userToken$.value, self);
  }

  private _refreshToken(oldToken, self) {
    //console.log("refreshToken: " + oldToken);
    return new Promise((resolve, reject) => {
      let httpHeaders = new HttpHeaders();
      httpHeaders = httpHeaders.set("Authorization", "Bearer " + oldToken);
      httpHeaders = httpHeaders.set("Content-Type", "application/json");
      let plf = "adr";
      if (self.plt.is("ios")) {
        plf = "ios";
      }
      let uid = self.device.uuid;
      if (uid == null) {
        uid = "HCB20168";
      }
      self.http
        .get(self.baseUrl + "/api/refreshToken?plf=" + plf + "&uid=" + uid, {
          headers: httpHeaders,
        })
        .subscribe(
          (res: any) => {
            console.log("refreshToken: " + res);
            if (res && res.token) {
              self._saveToken(res.token);
              if (res.contact && res.contact.name) {
                let temp = self.userProfile$.getValue();
                if (temp) {
                  temp.name = res.contact.name;
                  temp.email = res.contact.email;
                  temp.phone = res.contact.phone;
                  temp.country = res.contact.countryCode;
                  temp.town = res.contact.town;
                  temp.province = res.contact.province;

                  if (res.getting && res.getting.role) {
                    //let getting =
                    temp.gettingStarted = {};
                    temp.gettingStarted.role = res.getting.role;
                    temp.gettingStarted.medicine = res.getting.medicine;
                    temp.gettingStarted.interests = {};
                    temp.gettingStarted.interests.heart =
                      res.getting.interests.indexOf("heart") >= 0 ? true : null;
                    temp.gettingStarted.interests.cancer =
                      res.getting.interests.indexOf("cancer") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.copd =
                      res.getting.interests.indexOf("copd") >= 0 ? true : null;
                    temp.gettingStarted.interests.stroke =
                      res.getting.interests.indexOf("stroke") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.alzheimer =
                      res.getting.interests.indexOf("alzheimer") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.diabetes =
                      res.getting.interests.indexOf("diabetes") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.kidney =
                      res.getting.interests.indexOf("kidney") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.cholesterol =
                      res.getting.interests.indexOf("cholesterol") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.arthritis =
                      res.getting.interests.indexOf("arthritis") >= 0
                        ? true
                        : null;
                    temp.gettingStarted.interests.depression =
                      res.getting.interests.indexOf("depression") >= 0
                        ? true
                        : null;
                  }

                  self.saveUserProfile(temp);
                }
              }
            }
            resolve(res);
          },
          (err) => {
            console.log(err);
            reject(err);
          }
        );
    });
  }

  private _saveToken(token) {
    this.userToken$.next(token);
    //"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZjhjZjg3ZWEyY2Q2NjE2ZTAyZmQxNTAiLCJVSUQiOiJWTjIzMDg4MzIxODQiLCJmSUQiOiIxZnk3Tlp0akg4UEZtSmw1b1lUNEM5aDc2WTkzIiwiZW1haWwiOiJwaHVvbmd0bDNAZ21haWwuY29tIiwicm9sZXMiOjE2LCJpbWFnZSI6InVzZXIyIiwiZHBvaW50IjowLCJleHAiOjE2MTkxNDYyNzUsImlhdCI6MTYxMTU0MzA3NX0.5QAWsYSsU8o7HLCgkdVBhslAEBjDbozElgby3de4C_k"
    //const decoded = JSON.parse(window.atob(token.split(".")[1]));
    const decoded = JSON.parse(
      window.decodeURIComponent(window.escape(window.atob(token.split(".")[1])))
    );
    /*
      UID: "VN2308832184"
      dpoint: 0
      email: "phuongtl3@gmail.com"
      exp: 1619146275
      fID: "1fy7NZtjH8PFmJl5oYT4C9h76Y93"
      iat: 1611543075
      image: "user2"
      roles: 16
      _id: "5f8cf87ea2cd6616e02fd150"
      profile:
        countryCode: "vn"
        countryTel: "84"
        email: "phuongtl3@gmail.com"
        name: "PhÆ°Æ¡ng VÃµ"
        phone: "0905225011"
        province: "Há» ChÃ­ Minh"
        town: "TÃ¢n BÃ¬nh"
        verified: false
        _id: "5fa223e60f950b1d3853d279"
    */
    console.log(decoded);
    this.userData$.next(decoded);
    this.getUserImg();
    this.storage.set(TOKEN_KEY, token);
  }
  updateUserImg(newImg) {
    if (newImg == "userAvar") {
      let userInfo = this.userData$.value;
      if (userInfo) {
        userInfo.image = "userAvar";
        this.userData$.next(userInfo);
        this.userImg =
          this.baseUrl +
          "/images/users/" +
          userInfo._id +
          "/userAvar?" +
          new Date().getTime();
      }
    }
    return this.userImg;
  }
  getUserImg() {
    let userInfo = this.userData$.value;
    if (!userInfo || userInfo.image == "user2") {
      this.userImg = "/assets/images/profile.png";
    } else {
      this.userImg =
        this.baseUrl +
        "/images/users/" +
        userInfo._id +
        "/userAvar?" +
        new Date().getTime();
    }
    return this.userImg;
  }

  getEmailOTP(email) {
    let postData;
    postData = { email: email.trim().toLowerCase() };
    let checkCode = this.util.createCheckCode();
    postData.t = checkCode.t;
    postData.h = checkCode.h;
    return this.http
      .post(
        this.baseUrl + "/api/user/loginEmail",
        JSON.stringify(postData),
        this.httpOptions
      )
      .pipe(catchError(this.util.handleError));
  }

  loginCode(id, email, OTP) {
    // email OTP passcode
    // Normally make a POST request to your APi with your login credentials
    if (!OTP || !id || !email) {
      return of(null);
    }
    let postData;
    postData = { id, email };
    return this.http
      .post(
        this.baseUrl + "/api/user/verifyEmailCode/" + OTP,
        JSON.stringify(postData),
        this.httpOptions
      )
      .pipe(
        take(1),
        map((res: any) => {
          // Extract the JWT, here we just fake it
          // tslint:disable-next-line: max-line-length
          // return `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1Njc2NjU3MDYsImV4cCI6MTU5OTIwMTcwNiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiMTIzNDUiLCJmaXJzdF9uYW1lIjoiU2ltb24iLCJsYXN0X25hbWUiOiJHcmltbSIsImVtYWlsIjoic2FpbW9uQGRldmRhY3RpYy5jb20ifQ.4LZTaUxsX2oXpWN6nrSScFXeBNZVEyuPxcOkbbDVZ5U`;
          console.log(res);
          return res;
        }),
        switchMap(async (res: any) => {
          const token = res.stk;
          const afToken = res.ftk;
          if (token && afToken) {
            //const decoded = JSON.parse(window.atob(token.split(".")[1]));
            const decoded = JSON.parse(
              window.decodeURIComponent(
                window.escape(window.atob(token.split(".")[1]))
              )
            );
            console.log(decoded);
            this.userData$.next(decoded);
            try {
              //await this.afAuth.auth.signInWithCustomToken(afToken);
              //await this.afAuth.signInWithCustomToken(afToken);
              this.authState$.next(true);
              let temp;
              temp = this.userProfile$.getValue();
              if (temp) {
                temp.email = email;
              }
              this.saveUserProfile(temp);
              //this.userProfile.next(temp);
              //this.storage.set(PROFILE_KEY,temp);
              this.userToken$.next(token);
              const storageObs = from(this.storage.set(TOKEN_KEY, token));
              return decoded;
            } catch (err) {
              console.log(err);
              return null;
            }
          } else {
            return null;
          }
        }),
        catchError(this.util.handleError)
      );
  }

  loginPhone(verifyId, verifyCode, countryTel, countryName, phoneNumber) {
    // this.fireAuth.auth.signOut
    // Normally make a POST request to your APi with your login credentials
    if (
      !verifyId ||
      !verifyCode ||
      !countryTel ||
      !countryName ||
      !phoneNumber
    ) {
      return of(null);
    }
    let postData;
    postData = {
      countryTel: countryTel,
      countryName: countryName,
      phoneNum: phoneNumber,
      code: verifyCode,
      verifyId,
    };
    return this.http
      .post(
        this.baseUrl + "/api/user/loginPhone",
        JSON.stringify(postData),
        this.httpOptions
      )
      .pipe(
        take(1),
        map((res: any) => {
          // Extract the JWT, here we just fake it
          // tslint:disable-next-line: max-line-length
          // return `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1Njc2NjU3MDYsImV4cCI6MTU5OTIwMTcwNiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiMTIzNDUiLCJmaXJzdF9uYW1lIjoiU2ltb24iLCJsYXN0X25hbWUiOiJHcmltbSIsImVtYWlsIjoic2FpbW9uQGRldmRhY3RpYy5jb20ifQ.4LZTaUxsX2oXpWN6nrSScFXeBNZVEyuPxcOkbbDVZ5U`;
          console.log(res);
          return res;
        }),
        switchMap(async (res: any) => {
          const token = res.stk;
          const afToken = res.ftk;
          if (token && afToken) {
            //const decoded = JSON.parse(window.atob(token.split(".")[1]));
            const decoded = JSON.parse(
              window.decodeURIComponent(
                window.escape(window.atob(token.split(".")[1]))
              )
            );
            console.log(decoded);
            this.userData$.next(decoded);
            try {
              await this.afAuth.signInWithCustomToken(afToken);
              this.authState$.next(true);
              let temp;
              temp = this.userProfile$.getValue();
              if (temp) {
                temp.phone = phoneNumber; //.replace(countryTel,"0");
                temp.country = countryName;
              }
              this.saveUserProfile(temp);
              //this.userProfile.next(temp);
              //this.storage.set(PROFILE_KEY,temp);
              this.userToken$.next(token);
              const storageObs = from(this.storage.set(TOKEN_KEY, token));
              return decoded;
            } catch (err) {
              console.log(err);
              return null;
            }
          } else {
            return null;
          }
        }),
        catchError(this.util.handleError)
      );
    /*
    return this.http.post(this.baseUrl + '/api/user/verifyEmailCode/' + OTP, JSON.stringify(postData), this.httpOptions)
      .pipe(
        take(1),
        map((res: any) => {
          // Extract the JWT, here we just fake it
          // tslint:disable-next-line: max-line-length
          // return `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1Njc2NjU3MDYsImV4cCI6MTU5OTIwMTcwNiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiMTIzNDUiLCJmaXJzdF9uYW1lIjoiU2ltb24iLCJsYXN0X25hbWUiOiJHcmltbSIsImVtYWlsIjoic2FpbW9uQGRldmRhY3RpYy5jb20ifQ.4LZTaUxsX2oXpWN6nrSScFXeBNZVEyuPxcOkbbDVZ5U`;
          console.log(res);
          return res.tk;
        }),
        switchMap(token => {
          //const decoded = JSON.parse(window.atob(token.split('.')[1]));
          const decoded = JSON.parse(window.decodeURIComponent(window.escape(window.atob(token.split('.')[1]))));
          console.log(decoded);
          this.userData.next(decoded);
          this.authState.next(true);
          const storageObs = from(this.storage.set(TOKEN_KEY, token));
          return storageObs;
        }),
        catchError(this.handleError)
      );
      */
  }
  loginPhoneToken(idToken, countryTel, countryName, phoneNumber) {
    // this.fireAuth.auth.signOut
    // Normally make a POST request to your APi with your login credentials
    if (!idToken || !countryTel || !countryName || !phoneNumber) {
      return of(null);
    }
    let postData;
    postData = {
      idToken,
      countryTel: countryTel,
      countryName: countryName,
      phoneNum: phoneNumber,
    };
    return this.http
      .post(
        this.baseUrl + "/api/user/loginPhoneTK",
        JSON.stringify(postData),
        this.httpOptions
      )
      .pipe(
        take(1),
        map((res: any) => {
          // Extract the JWT, here we just fake it
          // tslint:disable-next-line: max-line-length
          // return `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1Njc2NjU3MDYsImV4cCI6MTU5OTIwMTcwNiwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoiMTIzNDUiLCJmaXJzdF9uYW1lIjoiU2ltb24iLCJsYXN0X25hbWUiOiJHcmltbSIsImVtYWlsIjoic2FpbW9uQGRldmRhY3RpYy5jb20ifQ.4LZTaUxsX2oXpWN6nrSScFXeBNZVEyuPxcOkbbDVZ5U`;
          console.log(res);
          return res;
        }),
        switchMap(async (res: any) => {
          const token = res.stk;
          const afToken = res.ftk;
          if (token && afToken) {
            //const decoded = JSON.parse(window.atob(token.split(".")[1]));
            const decoded = JSON.parse(
              window.decodeURIComponent(
                window.escape(window.atob(token.split(".")[1]))
              )
            );
            console.log(decoded);
            this.userData$.next(decoded);
            try {
              await this.afAuth.signInWithCustomToken(afToken);
              this.authState$.next(true);
              this.userToken$.next(token);
              const storageObs = from(this.storage.set(TOKEN_KEY, token));
              return decoded;
            } catch (err) {
              console.log(err);
              return null;
            }
          } else {
            return null;
          }
        }),
        catchError(this.util.handleError)
      );
  }

  getUser() {
    return this.userData$.value;
  }
  getUserToken() {
    return this.userToken$.value;
  }
  getUserUID() {
    let user = this.userData$.value;
    if (user && user.UID) {
      return user.UID;
    } else {
      return "";
    }
  }
  getUserRoles() {
    let user = this.userData$.value;
    if (user && user.roles) {
      return user.roles;
    } else {
      return 16;
    }
  }
  getUserProfile() {
    return this.userProfile$.value;
  }

  async saveUserProfile(newProfile) {
    this.userProfile$.next(newProfile);
    await this.storage.set(PROFILE_KEY, newProfile);
  }

  async saveDefaultPatient(newPatient: PatientModel) {
    let pID = this.getUserUID();
    let user = this.userData$.value;
    if (pID && user != null) {
      newPatient.PID = pID;
      newPatient.uid = user._id;
      this.defaultPatient$.next(newPatient);
      await this.storage.set(PATIENT_KEY + "DF1", newPatient);
    }
  }

  getUserProfileServer() {
    if (this.userToken$.value == "") {
      return of(null);
    }
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set(
      "Authorization",
      "Bearer " + this.userToken$.value
    );
    //httpHeaders = httpHeaders.set("Content-Type", "application/json");
    return this.http
      .get(this.baseUrl + "/api/user/profile/", { headers: httpHeaders })
      .pipe(
        /* take(1),
        switchMap(async (res: any) => {
          console.log(res);
          if (res) {
            return of(res);
          } else {
            return of(null);
          }
        }), */
        catchError(this.util.handleError)
      );
  }

  updateUserProfile(profile) {
    let user;
    user = this.userData$.getValue();
    if (!user || !user._id || !profile || !profile.name) {
      return of(null);
    }
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set(
      "Authorization",
      "Bearer " + this.userToken$.value
    );
    httpHeaders = httpHeaders.set("Content-Type", "application/json");
    let postData;
    postData = profile;
    return this.http
      .post(
        this.baseUrl + "/api/user/updateUserProfile/" + user._id,
        JSON.stringify(postData),
        { headers: httpHeaders }
      )
      .pipe(
        take(1),
        switchMap(async (res: any) => {
          const token = res.stk;
          if (token) {
            //const decoded = JSON.parse(window.atob(token.split(".")[1]));
            const decoded = JSON.parse(
              window.decodeURIComponent(
                window.escape(window.atob(token.split(".")[1]))
              )
            );
            console.log(decoded);
            this.userData$.next(decoded);
            const storageObs = from(this.storage.set(TOKEN_KEY, token));
            return decoded;
          } else {
            return null;
          }
        }),
        catchError(this.util.handleError)
      );
  }
  /*
  getUserStatedRemote() {
    let user;
    user = this.userData$.getValue();
    if (!user || !user._id) {
      return of(null);
    }

    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set(
      "Authorization",
      "Bearer " + this.userToken$.value
    );
    httpHeaders = httpHeaders.set("Content-Type", "application/json");
    return this.http.get(this.baseUrl + "/api/user/gettingStarted", {
      headers: httpHeaders,
    });
  }
*/
  updateUserStarted(gstarted) {
    //let profile;
    //profile = this.userProfile$.getValue();
    let user;
    user = this.userData$.getValue();
    if (!user || !user._id) {
      return of(null);
    }

    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set(
      "Authorization",
      "Bearer " + this.userToken$.value
    );
    httpHeaders = httpHeaders.set("Content-Type", "application/json");
    let postData;
    postData = gstarted;
    return this.http
      .post(
        this.baseUrl + "/api/user/updateUserStarted",
        JSON.stringify(postData),
        { headers: httpHeaders }
      )
      .pipe(catchError(this.util.handleError));
  }

  isAuthenticated() {
    return this.authState$.value;
  }

  uploadUserImg(formData, cmd) {
    let httpHeaders = new HttpHeaders();
    httpHeaders.set("Authorization", "Bearer " + this.userToken$.value);
    let promise = new Promise((resolve, reject) => {
      this.http
        .post(
          this.baseUrl +
            "/api/users/uploadfile.php?cmd=" +
            cmd +
            "&id=" +
            this.userData$.value._id,
          formData,
          { headers: httpHeaders }
        )
        .toPromise()
        .then(
          (response) => {
            //Success
            //let result = response.json();
            console.log(response);
            resolve(response);
          },
          (err) => {
            //Error
            reject(err);
          }
        );
    });
    return promise;
  }

  updateUserProfProfile(postData: any) {
    let httpHeaders = new HttpHeaders();
    //httpHeaders = httpHeaders.set('Content-Type', 'application/json');
    httpHeaders = httpHeaders.set(
      "Authorization",
      "Bearer " + this.userToken$.value
    );
    let promise = new Promise((resolve, reject) => {
      if (postData) {
        this.http.post(this.baseUrl + "/api/user/profProfile", postData, { headers: httpHeaders })
          .toPromise()
          .then(response => {//Success
            console.log(response);
            resolve(response);
          }, err => {//Error
            reject(err);
          });
      } else {
        reject(new Error("no postData"));
      }
    });
    return promise;
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.storage
        .remove(TOKEN_KEY)
        .then(() => {
          this.router.navigateByUrl("/");
          this.userData$.next(null);
          this.authState$.next(false);
          this.userToken$.next("");
          this.afAuth
            .signOut()
            .then(() => {
              resolve(true);
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
          // throw new Error(err);
        });
    });
  }
  /*
  // Handle API errors
  handleError(error: HttpErrorResponse) {
    let ms;
    let status;
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error("An error occurred:", error.error.message);
      ms = "Network error!, Please check your Internet Connection!";
      status = 0;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      ms = JSON.stringify(error.error);
      status = error.status;
      console.error(`Backend returned code ${status}, ` + `body was: ${ms}`);
    }
    // return an observable with a user-facing error message
    return throwError({ message: ms, code: status });
  }
  async presentToast(ms) {
    const toast = await this.toastCtrl.create({
      message: ms, // 'Your settings have been saved.',
      duration: 3000,
    });
    await toast.present();
  }
  async presentLoading(msg, ms?) {
    if (this.loading) {
      await this.loading.dismiss();
    }
    this.loading = await this.loadingCtrl.create({
      message: msg,
      duration: ms ? ms : 3000,
    });
    await this.loading.present();
  }
  async closeLoading() {
    if (this.loading) {
      await this.loading.dismiss();
    }
  }
  async presentAlert(title, msg) {
    if (this.alert) {
      await this.alert.dismiss();
    }
    this.alert = await this.alertCtrl.create({
      header: title,
      message: msg,
      buttons: ["OK"],
    });
    await this.alert.present();
  }
  */
}
